// Performance monitoring utility
class PerformanceMonitor {
  constructor() {
    this.metrics = {};
    this.init();
  }

  init() {
    // Monitor Core Web Vitals
    this.monitorLCP();
    this.monitorFID();
    this.monitorCLS();
    this.monitorFCP();
    this.monitorTTFB();
  }

  // Largest Contentful Paint
  monitorLCP() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const lastEntry = entries[entries.length - 1];
        this.metrics.lcp = lastEntry.startTime;
        this.logMetric('LCP', lastEntry.startTime);
      });
      observer.observe({ entryTypes: ['largest-contentful-paint'] });
    }
  }

  // First Input Delay
  monitorFID() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          this.metrics.fid = entry.processingStart - entry.startTime;
          this.logMetric('FID', this.metrics.fid);
        });
      });
      observer.observe({ entryTypes: ['first-input'] });
    }
  }

  // Cumulative Layout Shift
  monitorCLS() {
    if ('PerformanceObserver' in window) {
      let clsValue = 0;
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          if (!entry.hadRecentInput) {
            clsValue += entry.value;
            this.metrics.cls = clsValue;
            this.logMetric('CLS', clsValue);
          }
        });
      });
      observer.observe({ entryTypes: ['layout-shift'] });
    }
  }

  // First Contentful Paint
  monitorFCP() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        const firstEntry = entries[0];
        this.metrics.fcp = firstEntry.startTime;
        this.logMetric('FCP', firstEntry.startTime);
      });
      observer.observe({ entryTypes: ['paint'] });
    }
  }

  // Time to First Byte
  monitorTTFB() {
    if ('PerformanceObserver' in window) {
      const observer = new PerformanceObserver((list) => {
        const entries = list.getEntries();
        entries.forEach((entry) => {
          if (entry.entryType === 'navigation') {
            this.metrics.ttfb = entry.responseStart - entry.requestStart;
            this.logMetric('TTFB', this.metrics.ttfb);
          }
        });
      });
      observer.observe({ entryTypes: ['navigation'] });
    }
  }

  logMetric(name, value) {
    console.log(`Performance Metric - ${name}: ${value}ms`);
    
    // Send to analytics if available
    if (window.gtag) {
      window.gtag('event', 'performance_metric', {
        metric_name: name,
        metric_value: value
      });
    }
  }

  getMetrics() {
    return this.metrics;
  }

  // Custom performance mark
  mark(name) {
    if ('performance' in window) {
      performance.mark(name);
    }
  }

  // Custom performance measure
  measure(name, startMark, endMark) {
    if ('performance' in window) {
      try {
        const measure = performance.measure(name, startMark, endMark);
        console.log(`Performance Measure - ${name}: ${measure.duration}ms`);
        return measure.duration;
      } catch (error) {
        console.warn(`Could not measure ${name}:`, error);
      }
    }
  }
}

// Initialize performance monitor
const performanceMonitor = new PerformanceMonitor();

export default performanceMonitor;

